import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
// import { Row, Col } from 'react-bootstrap';
import Committeeleft from './Committeeleft';
import { Container, Row,Col } from 'react-bootstrap';
import Breadcrumb from '../../Breadcrumb/Main'
import { Table } from 'react-bootstrap';

function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title='Home' subtitle="Mental Health and Well-being Monitoring Committee" />
            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <div className="lower-content">

                        <Row>

                        <Col md={3} className='c-left custom-padding-color mb-4'>
                        <Committeeleft></Committeeleft>
                        </Col>
                
                        <Col md={9} className='c-right'>

                            
                                <h3 className='c-headline mb-3'>Mental Health and Well-being Monitoring Committee</h3>
                                <p className='caboutus c-lineheight2dot5'>This is to inform all that the Mental Health and Well-being Monitoring Committee for the students of the Institute is constituted with the following members, with immediate effect and until further orders:</p>

                               
                                <Table bordered responsive className='mt-3'>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <p>Dean, Student Affairs</p>
                                                
                                            </td>
                                            <td>Chairperson</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Faculty Advisor, Guidance & Counselling Unit</p>
                                               
                                                
                                            </td>
                                            <td> Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Dr. Sruthi Kodidini</p>
                                                <p>Medical Officer</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Chairperson, Council of Wardens</p>
                                                
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Dr. Jaynarayan T Tudu</p>
                                                <p>Assistant Professor </p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Assistant Security Officer</p>
                                                <p>Assistant Registrar - Student Affairs</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Guidance & Counselling Unit - Student Head</p>
                                                
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Mr. Pranav Raj. P, Student Counsellor</p>
                                                
                                            </td>
                                            <td>Nodal Officer</td>
                                        </tr>

                                        
                                    </tbody>

                                </Table>

                               


                                <p className=' fw-bold c-headline caboutus mt-3 mb-3'>Key Function of the Committee:</p>
                                <ul className='ms-3 c-lineheight2dot5 iarrow caboutus' >
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Review Student mental health and psychosocial well-being concerns periodically.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />	Identify emerging issues/trends and suggest appropriate interventions.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />	Facilitate coordination among the counselling, medical, faculty, hostel, and student bodies.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />	Recommend awareness programmes and preventive initiatives.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Review the effectiveness and accessibility of support services.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Ensure confidentiality and ethical handling of sensitive matters.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Submit periodic recommendations/reports to the competent Authority.</li>
                                </ul>

                                </Col>

                           
                        </Row>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Main;